import { fetch } from '../utils/fetch';

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryPrices(priceId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-price/${priceId}`,
    method: 'get',
  });
}

export function _queryPriceByGoodsId(
  {
    page, size, direction, sort, goodsId
  }) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-price`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
      goodsId
    },
  });
}

/**
 * 新增
 * @param  name
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addPrice(
  {
    goodsId,
    paramKey,
    paramValue,
    country,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-price`,
    method: 'post',
    data: {
      goodsId,
      paramKey,
      paramValue,
      country,
    },
  });
}

/**
 * 更新
 * @param goodsCategoryId
 * @param  name
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updatePrice(priceId, {
  goodsId,
  paramKey,
  paramValue,
  country,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-price/${priceId}`,
    method: 'patch',
    data: {
      goodsId,
      paramKey,
      paramValue,
      country,
    },
  });
}

/**
 * 删除
 * @param goodsCategoryId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deletePrice(priceId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-price/${priceId}`,
    method: 'delete',
  });
}

export function _updateGoodsSort({ idStr, sortStr, oldIndex, newIndex
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website/price/update`,
    method: 'post',
    params: {
      idStr: idStr,
      sortStr: sortStr,
      oldIndex: oldIndex,
      newIndex: newIndex
    }
  });
}

export default {};
